import { useEffect, useState } from 'react';
import { PER_PAGE_OPTIONS } from '@library/constants/common';
import type { SelectOption } from '@library/types/utils';

export function usePerPage() {
  const storedPerPage = localStorage.getItem(`perPage`) ?? '100';

  const [selectedPerPage, setSelectedPerPage] = useState<string>(storedPerPage);

  useEffect(() => {
    localStorage.setItem('perPage', selectedPerPage);
  }, [selectedPerPage]);

  const handleSelectPerPage = (perPageOption: SelectOption) => {
    setSelectedPerPage(perPageOption.value);
  };

  return {
    handleSelectPerPage,
    perPageOptions: PER_PAGE_OPTIONS,
    selectedPerPage
  };
}
